/* eslint-disable */
import React, { Component } from 'react';
import ReactTable from 'react-table';
import treeTableHOC from 'react-table/lib/hoc/treeTable';
import styled from 'styled-components';

import { Button } from './Button';
import { MeasurementEdit } from './MeasurementEdit';
import { ModalComponent } from './Modal';

import { formatAtributeName } from '../services/formatAtributeName';
import { sortAttributes, splitCoordinates, showUnits } from '../services/attributesServices';

const SelectTreeTable = treeTableHOC(ReactTable)

const OverrideTable = styled.div`
  width: 100%;
  height: 100%;
  .rt-tbody, .rt-head {
    width: ${(props) => props.width * 120}px;
  }
`;

const CopyButton = styled.button`
  width: 15px;
  height: 15px;
  background-color: transparent;
  background-image: url('/ic-copy.svg');
  background-size: 15px;
  margin-left: 10px;
  cursor: pointer;
  border: none;

  &:hover {
    background-image: url('/ic-copy-hover.svg');
  }
`;

export class EditableTable extends Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleExpand = this.handleExpand.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.handleToggleEdit = this.handleToggleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.renderSelectComponent = this.renderSelectComponent.bind(this);
    this.renderEditable = this.renderEditable.bind(this);
    this.onHideCopy = this.onHideCopy.bind(this);
    this.onShowCopy = this.onShowCopy.bind(this);
    this.handleCopySave = this.handleCopySave.bind(this);
    this.state = {
      data: props.data,
      edit: props.edit,
      selected: [],
      expanded: {},
      showCopy: false,
      copyElement: null,
    }
  }

  renderSelectComponent(props) {
    if (!props.original) {
      return null;
    }

    return (
      <div>
        <input
          id={props.original.id}
          onChange={this.handleSelect}
          checked={this.state.selected.includes(`${props.original.id}`)}
          type="checkbox"
        />
        <CopyButton onClick={() => this.onShowCopy(props.original)} />
      </div>
    )
  }

  componentWillReceiveProps(nextState) {
    this.setState({data: nextState.data})
  }

  handleDelete() {
    this.props.checkboxDelete(this.state.selected);
  }

  handleSelect(e) {
    const id = e.target.id;
    if (this.state.selected.includes(id)) {
      this.setState((prevState) => ({
        selected: prevState.selected.filter((item) => item !== id)
      }))
    } else {
      this.setState((prevState) => ({selected: [id, ...prevState.selected]}))
    }
  }

  renderEditable(cellInfo) {
    if (!cellInfo.column || cellInfo.index === undefined) {
      return null;
    }

    const { data } = this.state;
    const columnName = cellInfo.column.id;
    const index = cellInfo.index;

    if (this.state.edit && columnName !== 'element_id' && columnName !== 'id') {
      return (
        <input
          value={data[index][columnName] || ''}
          id={index}
          name={columnName}
          onChange={this.handleDataChange}
          type="text"
        />
      );
    }

    return (
      <span>
        {data[index][columnName]}
      </span>
    );
  }

  handleToggleEdit() {
    if (this.state.edit) {
      this.state.data.forEach((item, i) => {
        const newItem = item;
        newItem.coordinates = [item.latitude, item.longitude];
        delete newItem.latitude;
        delete newItem.longitude;
        delete newItem.dateShort;

        this.props.onSave(newItem);
      })
    }
    this.setState((prevState) => ({edit: !prevState.edit}));
  }

  handleDataChange(e) {
    const newData = this.state.data;
    newData[e.target.id][e.target.name] = e.target.value;
    this.setState({data: newData});
  }

  handleExpand(expand) {
    this.setState({expanded: expand})
  }

  onHideCopy() {
    this.setState({
      showCopy: false,
      copyElement: null,
    });
  }

  onShowCopy(element) {
    this.setState({
      showCopy: true,
      copyElement: element,
    });
  }

  handleCopySave(elements) {
    this.props.handledMeasurementAdd(elements, this.props.selectedElementId);
    this.onHideCopy();
  }

  render() {
    const { data, showCopy } = this.state;
    const { selected, checkboxDelete } = this.props;
    const columns = [
      {
        Header: <Button onClick={this.handleDelete}>DELETE</Button>, // eslint-disable-line
        accessor: 'select',
        Cell: this.renderSelectComponent,
        width: 120,
      },
      ...selected && sortAttributes([...selected, {item: 'dateShort', checked: true}]).filter((item) => item.checked).map(({item}) => ({
        Header: <span className="custom-cell">{formatAtributeName(item)}{showUnits(item)}</span>, // eslint-disable-line
        accessor: item,
        Cell: this.renderEditable,
        width: 120,
      })),
    ]
    const allElements = data.map((item) => {
      let newItem = item;
      newItem = splitCoordinates(item);
      newItem.dateShort = item.date ? item.date.substr(0, 10) : '';
      return newItem
    });

    return (
      <OverrideTable width={selected.filter((item) => item.checked).length + 1}>
        <ModalComponent
          big
          handleHide={this.onHideCopy}
          open={showCopy}
          title='COPY MEASUREMENT'
        >
          <MeasurementEdit
            onSave={this.handleCopySave}
            element={this.state.copyElement}
          />
        </ModalComponent>
        <SelectTreeTable
          data={allElements}
          columns={columns}
          freezWhenExpanded={true}
          resizable
          pivotBy={['dateShort']}
          expanded={this.state.expanded}
          onExpandedChange={this.handleExpand}
          selectType="checkbox"
          sortable={false}
          FilterComponent={() => null}
          PreviousComponent={() => <Button type={!this.state.edit ? 'primary' : 'secondary'} onClick={this.handleToggleEdit}>EDIT {this.state.edit ? 'ON' : 'OFF'}</Button>}
          NextComponent={() => null}
          style={{height: '100%', width: '100%'}}
        />
      </OverrideTable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditableTable.js